import React, { useState, useEffect } from 'react';
import '../../css/onboardingLinkCardSteps.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from "react-icons/fa6";
import ImgPorMultibancoSvg from '../../assets/svg/iconPorMultibanco.svg';
import ImgPorMbWaySvg from '../../assets/svg/iconPorMbWay.svg';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import Heading from '../../components/Heading';
import CustomBreadcrumbsAddCards from '../../components/Breadcrumbs/CustomBreadcrumbsAddCards';
import { useDispatch, useSelector } from 'react-redux';
import { setClientId } from '../../features/onboardingData/onboardingUserData';
import GifAnim from '../../components/GifAnim';

function LinkCardStepOne() {

    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const isClientId = useSelector((state) => state.onboardingUserData.isClientId);

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    const hadleBtnBoxMbWay = () => {
        navigate('/configuracoes/associar-cartao/mbway');
    };

    const hadleBtnBoxMB = () => {
        navigate('/configuracoes/associar-cartao/multibanco');
    };

    const handleEmailClick = () => {
        const emailAddress = 'geral@saude360.medis.pt';
        const mailtoLink = `mailto:${emailAddress}`; 
    
        window.location.href = mailtoLink;
    }

  return (  
    <>
    <Header/> 
    { isLoading ? 
        <GifAnim />
    :
    <div className={ isTablet ? "mainViewContainerLinckCardSteps" : ( isMobile ? "mainViewContainerLinckCardStepsTablet" : "mainViewContainerLinckCardStepsMobile")}>
        <div className={ isTablet ? 'firstTxtViewContainerLinckCardSteps' : ( isMobile ? 'firstTxtViewContainerLinckCardStepsTablet' : 'firstTxtViewContainerLinckCardStepsMobile') }>
            <div className='mainHeadingViewContainerLinckCardSteps'> 
                <CustomBreadcrumbsAddCards hasCardType />
                <Heading hasBtnBack={false}/>
            </div>
            <div className={ isTablet ? 'secondMainContainerLinckCardSteps' : ( isMobile ? 'secondMainContainerLinckCardSteps' : 'secondMainContainerLinckCardStepsMobile') }>
                <div className={ isTablet ? 'firstSubMainContainerLinckCardSteps'  : 'firstSubMainContainerLinckCardStepsMobile' }>
                    <div className={ isTablet ? 'secondTitleViewLinckCardSteps' : 'secondTitleViewLinckCardStepsMobile' }>
                        <span className={  isTablet ? 'textTitleRegular400LinckCardSteps' : ( isMobile ? 'textTitleRegular400LinckCardStepsTablet' : 'textTitleBold700LinckCardStepsMobile' ) }>Associe um cartão bancário</span>
                    </div>
                    <div className={ isTablet ? 'txtSecondTitleViewLinckCardSteps': 'secondTitleViewLinckCardStepsMobile' }>
                        <div className='textSecondTitleViewLinckCardSteps'>Associe no máximo 5 cartões, através da app MB WAY ou de um MULTIBANCO.</div>
                    </div>
                    <div className={ isTablet ? 'txtSecondTitleViewLinckCardSteps': 'secondTitleViewLinckCardStepsMobile' }>
                        <div className='textSecondTitleViewLinckCardSteps'>Para associar através do MULTIBANCO, utilize o seguinte número.</div>
                    </div>
                    <div className='placeholderExampleContainer'>
                        <div className='txtPlaceholderExample'>{isClientId}</div>
                    </div>
                    
                    { !isMobile && (
                        <>
                        <button className={ isMobile ? 'navBoxViewContainerLinckCardStepsTablet' : 'navBoxViewContainerLinckCardStepsMobile' } onClick={hadleBtnBoxMbWay}>
                            <div className={'navBoxInnerContentLinckCardSteps'}>
                                <img src={ImgPorMbWaySvg} alt="imagem" className={ isMobile ? 'imagemNavBoxSvg' : 'imagemNavBoxSvgMobile'} />
                                <div className='txtNavBoxTitleViewContainerLinckCardSteps'>
                                    <div className='txtNavBoxTitleLinckCardStepsMobile'>Na app MB Way</div>
                                </div>
                                <div className='txtNavBoxViewContainerLinckCardSteps'>
                                    <div className='txtNavBoxRegularLinckCardSteps'>Associe um cartão em segundos <br/> usando a app MB Way</div>
                                </div>
                            </div>
                            <div className='arrowIconNavBoxViewContainerLinckCardSteps'>
                                    <FaArrowRight className='arrowIconNavBoxLinckCardSteps' /> 
                            </div>
                        </button>

                        <button className={ isMobile ? 'navBoxViewContainerLinckCardStepsTablet' : 'navBoxViewContainerLinckCardStepsMobile' } onClick={hadleBtnBoxMB}>
                            <div className={'navBoxInnerContentLinckCardSteps'}>
                                <img src={ImgPorMultibancoSvg} alt="imagem" className={ isMobile ? 'imagemNavBoxSvg' : 'imagemNavBoxSvgMobile'} />
                                <div className='txtNavBoxTitleViewContainerLinckCardSteps'>
                                    <div className='txtNavBoxTitleLinckCardStepsMobile'>No MULTIBANCO</div>
                                </div>
                                <div className='txtNavBoxViewContainerLinckCardSteps'>
                                    <div className='txtNavBoxRegularLinckCardSteps'>Associe um cartão <br /> usando um ATM</div>
                                </div>
                            </div>
                                <div className='arrowIconNavBoxViewContainerLinckCardSteps'>
                                    <FaArrowRight className='arrowIconNavBoxLinckCardSteps' /> 
                                </div>
                        </button>
                        </>
                    )}
                </div>

                { isTablet ? (
                    <div className='navBoxMainViewContainerLinckCardSteps'>
                        <button className='navBoxViewContainerLinckCardSteps' onClick={hadleBtnBoxMbWay}>
                            <div className='navBoxInnerContentLinckCardSteps'>
                                <img src={ImgPorMbWaySvg} alt="imagem" className="imagemNavBoxSvg" />
                                <div className='txtNavBoxTitleViewContainerLinckCardSteps'>
                                    <div className='txtNavBoxTitleLinckCardSteps'>Na app MB Way</div>
                                </div>
                                <div className='txtNavBoxViewContainerLinckCardSteps'>
                                    <div className='txtNavBoxRegularLinckCardSteps'>Associe um cartão em segundos <br/> usando a app MB Way</div>
                                </div>
                            </div>
                            <div className='arrowIconNavBoxViewContainerLinckCardSteps'>
                                <FaArrowRight className='arrowIconNavBoxLinckCardSteps' /> 
                            </div>
                        </button>

                        <button className='navBoxViewContainerLinckCardSteps' onClick={hadleBtnBoxMB}>
                            <div className='navBoxInnerContentLinckCardSteps'>
                                <img src={ImgPorMultibancoSvg} alt="imagem" className="imagemNavBoxSvg" />
                                <div className='txtNavBoxTitleViewContainerLinckCardSteps'>
                                    <div className='txtNavBoxTitleLinckCardSteps'>No MULTIBANCO</div>
                                </div>
                                <div className='txtNavBoxViewContainerLinckCardSteps'>
                                    <div className='txtNavBoxRegularLinckCardSteps'>Associe um cartão <br /> usando um ATM</div>
                                </div>
                            </div>
                            <div className='arrowIconNavBoxViewContainerLinckCardSteps'>
                                <FaArrowRight className='arrowIconNavBoxLinckCardSteps' /> 
                            </div>
                        </button>
                    </div>
                ) : ( isMobile ? (
                    <div className='navBoxMainViewContainerLinckCardStepsTablet'>
                        <button className='navBoxViewContainerLinckCardStepsTablet' onClick={hadleBtnBoxMbWay}>
                            <div className='navBoxInnerRowContentLinckCardSteps'>
                                <img src={ImgPorMbWaySvg} alt="imagem" className="imagemNavBoxSvg" />
                                <div className='txtNavBoxTitleViewContainerLinckCardSteps'>
                                    <div className='txtNavBoxTitleLinckCardStepsMobile'>Na app MB Way</div>
                                </div>
                            </div>
                            <div className='navBoxInnerRowSpaceContentLinckCardSteps'>
                                <div className='txtNavBoxViewContainerLinckCardSteps'>
                                        <div className='txtNavBoxRegularLinckCardSteps'>Associe um cartão em segundos usando a app MB Way</div>
                                    </div>
                                <div className='arrowIconNavBoxViewContainerLinckCardSteps'>
                                    <FaArrowRight className='arrowIconNavBoxLinckCardSteps' /> 
                                </div>
                            </div>
                        </button>

                        <button className='navBoxViewContainerLinckCardStepsTablet' onClick={hadleBtnBoxMB}>
                            <div className='navBoxInnerRowContentLinckCardSteps'>
                                <img src={ImgPorMultibancoSvg} alt="imagem" className="imagemNavBoxSvg" />
                                <div className='txtNavBoxTitleViewContainerLinckCardSteps'>
                                    <div className='txtNavBoxTitleLinckCardStepsMobile'>No MULTIBANCO</div>
                                </div>
                            </div>
                            <div className='navBoxInnerRowSpaceContentLinckCardSteps'>
                                <div className='txtNavBoxViewContainerLinckCardSteps'>
                                        <div className='txtNavBoxRegularLinckCardSteps'>Associe um cartão usando um ATM</div>
                                    </div>
                                <div className='arrowIconNavBoxViewContainerLinckCardSteps'>
                                    <FaArrowRight className='arrowIconNavBoxLinckCardSteps' /> 
                                </div>
                            </div>
                        </button>
                    </div>
                    )   : null 
                )}
            </div>  
            <div className='contactInfoViewContainerLinckCardSteps'>
                <div className='txtContactInfoViewContainerLinckCardSteps'>
                    { isTablet ?
                        <>
                        <div className='txtContactInfoBoldLinckCardSteps'>Tem dúvidas?</div>
                        <div className='txtContactInfoRegularLinckCardSteps'>
                            <span className='txtContactInfoRegularLinckCardSteps'>Contacte-nos pelo <span className='txtContactInfoRegularUnderLineGreenLinckCardSteps' style={{ cursor: 'pointer' }} onClick={handleEmailClick}>geral@saude360.medis.pt</span> </span>
                            <span className='txtContactInfoRegularLinckCardSteps'>ou através do <span className='txtContactInfoRegularUnderLineGreenLinckCardSteps'>210 204 887</span> </span>
                            <div className='txtContactInfoRegularLinckCardSteps'>(dias úteis, das 9h às 18h).</div>
                        </div>
                        </>
                        :
                        <>
                        <div className='txtContactInfoBoldLinckCardStepsMobile'>Tem dúvidas?</div>
                        <div className='txtContactInfoRegularLinckCardSteps'>
                            <div className='txtContactInfoRegularLinckCardSteps'>Contacte-nos pelo <span className='txtContactInfoRegularUnderLineGreenLinckCardSteps' style={{ cursor: 'pointer' }} onClick={handleEmailClick}>geral@saude360.medis.pt</span> </div>
                            <div className='txtContactInfoRegularLinckCardSteps'>ou através do <span className='txtContactInfoRegularUnderLineGreenLinckCardSteps'>210 204 887</span> </div>
                            <div className='txtContactInfoRegularLinckCardSteps'>(dias úteis, das 9h às 18h).</div>
                        </div>
                        </>
                    }
                </div>
                <div className='txtSmallContactInfoViewContainerLinckCardSteps'>
                    <div className='optionsDeviderLineLinckCardSteps'></div>
                    <div className='txtSmallContactInfoRegularLinckCardSteps'>Custo de chamada para Rede Fixa Nacional.</div>
                </div>    
            </div>       
        </div>
    </div>
    }
    <Footer/> 
    </>
  )
}

export default LinkCardStepOne;